import React from 'react';
import { Pencil } from 'lucide-react';
import type { Material } from '../../types/material';
import { CardListSkeleton } from '../../../../components/TableSkeleton';
import { formatMaterialPrice, isOmdCatalogMaterial } from '../../utils/materialForm';

type MaterialMobileCardListProps = {
  materials: Material[];
  loading: boolean;
  emptyMessage: string;
  onOpenOmdPanel: (m: Material) => void;
  onEditMaterial: (m: Material) => void;
  omdEnabledSlugs: ReadonlySet<string>;
};

export function MaterialMobileCardList({
  materials,
  loading,
  emptyMessage,
  onOpenOmdPanel,
  onEditMaterial,
  omdEnabledSlugs,
}: MaterialMobileCardListProps) {
  if (loading) {
    return <CardListSkeleton label="Materialien werden geladen …" />;
  }

  if (materials.length === 0) {
    return <p className="px-4 py-6 text-center text-xs text-app-text-subtle">{emptyMessage}</p>;
  }

  return (
    <>
      {materials.map((m) => (
        <div
          key={m.id}
          className="px-4 py-3 flex items-start gap-3 cursor-pointer hover:bg-app-hover active:bg-app-surface-muted"
          onClick={() => {
            if (isOmdCatalogMaterial(m, omdEnabledSlugs)) {
              onOpenOmdPanel(m);
              return;
            }
            onEditMaterial(m);
          }}
        >
          <div className="flex-1 min-w-0 text-app-text-subtle">
            <p className="text-sm font-medium truncate">{m.name}</p>
            <p className="text-xs truncate">
              {[m.brand, m.supplier].filter(Boolean).join(' · ') || '-'} &nbsp;·&nbsp; {m.unit || '-'}
            </p>
          </div>
          <div className="shrink-0 flex items-start gap-2 text-left text-app-text-subtle">
            <div>
              <p className="text-sm font-semibold">{formatMaterialPrice(m.gross_price)} VK</p>
              <p className="text-xs">{formatMaterialPrice(m.net_price)} EK</p>
            </div>
            {isOmdCatalogMaterial(m, omdEnabledSlugs) && (
              <button
                type="button"
                className="p-1.5 rounded-lg hover:bg-app-hover"
                title="Bearbeiten"
                aria-label="Bearbeiten"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditMaterial(m);
                }}
              >
                <Pencil className="w-4 h-4 text-app-text-subtle" />
              </button>
            )}
          </div>
        </div>
      ))}
    </>
  );
}
